import axios from "axios";
export const retrieveTokens = () => ({
  token: localStorage.getItem("token"),
});

export const storeTokens = (token) => {
  localStorage.setItem("token", token);
};

export const clearTokens = () => {
  localStorage.removeItem("token");
};

export function parseJwt(token) {
  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split("")
      .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
      .join(""),
  );
  return JSON.parse(jsonPayload);
}

export function getIsAdmin() {
  const { token } = retrieveTokens();
  if (!token) return false;
  try {
    const payload = parseJwt(token);
    return payload.scopes?.includes("admin") || false;
  } catch {
    return false;
  }
}

export const validateTokenWithAPI = async () => {
  try {
    const { token } = retrieveTokens();
    const response = await axios.post(
      `${process.env.REACT_APP_CALENDER_API}/users/me`,
      {},
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
    console.log("Token validation response:", response);
    if (response.status === 200) {
      return getIsAdmin(); // admin status from JWT payload — format-independent
    } else {
      clearTokens();
      return null;
    }
  } catch (error) {
    if (
      error.response?.status === 401 ||
      error.response?.status === 403 ||
      error.response?.status === 422 ||
      error.message?.includes("unauthorized")
    ) {
      console.log("Token validation failed!");
      clearTokens();
      return null; // definitively invalid auth
    }
    // Network error, server error, etc. — don't clear a potentially valid token
    return undefined;
  }
};
